"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var signup_signin_modal_1 = require("@reverbdotcom/commons/dist/components/signup_signin_modal");
var location_util_1 = require("../../shared/location_util");
var bind_1 = require("../../../bind");
var constants_1 = require("../../shared/constants");
var lodash_1 = require("lodash");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var classNames = require('classnames');
var LoggedOutFollowButton = /** @class */ (function (_super) {
    tslib_1.__extends(LoggedOutFollowButton, _super);
    function LoggedOutFollowButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            modalOpen: props.modalOpen,
        };
        return _this;
    }
    LoggedOutFollowButton.prototype.handleClick = function (evt) {
        evt.preventDefault();
        tracker_1.trackInteraction({
            componentName: this.props.trackerEventName || 'FollowButton',
        });
        this.setState({ modalOpen: true });
    };
    LoggedOutFollowButton.prototype.handleModalClose = function () {
        this.setState({ modalOpen: false });
    };
    LoggedOutFollowButton.prototype.getButtonText = function () {
        return (this.props.addText ||
            I18n.t('discovery.addFollowToFeed.followThis', { type: I18n.t('discovery.addFollowToFeed.followType.search') }));
    };
    LoggedOutFollowButton.prototype.showShopFollowerCount = function () {
        var params = this.props.followParams;
        if (!lodash_1.get(this.props, 'followers.count'))
            return;
        if (!params.shop)
            return;
        return (React.createElement("p", { className: "mtb-half size-90 opacity-90 align-center" },
            React.createElement("span", { className: "weight-bold pr-half" }, this.props.followers.display),
            I18n.t('discovery.addFollowToFeed.followers')));
    };
    LoggedOutFollowButton.prototype.renderLoginModal = function () {
        var _a;
        var followPromptParams = (_a = {}, _a[constants_1.FOLLOW_PROMPT_PARAM] = true, _a);
        var redirectTo = location_util_1.default.currentPageWithParams(followPromptParams);
        return (React.createElement(signup_signin_modal_1.default, { onRequestClose: this.handleModalClose, active: this.state.modalOpen, message: I18n.t('discovery.searchSignup.fullLoginMessage'), redirectTo: redirectTo, trackSource: "FollowButton" }));
    };
    LoggedOutFollowButton.prototype.render = function () {
        var classes = classNames('feed-button__follow', { 'feed-button__follow--styled': !this.props.unstyled && !this.props.outlined }, { 'feed-button__follow--outlined': this.props.outlined });
        return (React.createElement("div", { className: "feed-button" },
            React.createElement("a", { className: classes, onClick: this.handleClick }, this.getButtonText()),
            this.showShopFollowerCount(),
            this.renderLoginModal()));
    };
    LoggedOutFollowButton.defaultProps = {
        unstyled: false,
    };
    tslib_1.__decorate([
        bind_1.default
    ], LoggedOutFollowButton.prototype, "handleClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], LoggedOutFollowButton.prototype, "handleModalClose", null);
    return LoggedOutFollowButton;
}(React.Component));
exports.LoggedOutFollowButton = LoggedOutFollowButton;
exports.default = user_context_provider_1.withUserContext(LoggedOutFollowButton);
//# sourceMappingURL=logged_out_follow_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/logged_out_follow_button.js
// module id = 6XW2
// module chunks = 20 21